






































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import DataGridOptions from './DataGridOptions';
import DataGridRowObject from './DataGridRowObject';
import DataGridService from './DataGridService';

@Component
export default class DataGrid extends Vue {
    @Prop() private searchterms!: any;
    @Prop() private options!: DataGridOptions;

    private LocalSearchTerms: any;
    private NewItemRow: DataGridRowObject = new DataGridRowObject();
    private GridData: DataGridRowObject[] = [];
    private TotalPages: number = 0;
    private CurrentPage: number = 1;
    private PageRange = 10;
    private NewItemVisible: boolean = false;
    private SelectedId: number = -1;
    private RelationId: number = -1;
    private IsLoading: boolean = false;

    private Search(searchTerms: Map<string, any>) {
        this.LocalSearchTerms = searchTerms;
        this.ChangePage(1);
    }

    private async created() {
        this.LocalSearchTerms = this.searchterms;
        await this.ChangePage(1);
        if (this.HasNewRow()) {
            this.NewItemRow.ToggleDetails = (item: DataGridRowObject) => {
                item.IsExpanded = !item.IsExpanded;
            };
        }
    }

    private HasDetails(): boolean {
        return !!this.$scopedSlots['row-details'];
    }

    private HasNewRow(): boolean {
        return !!this.$scopedSlots['row-newitem'];
    }

    private async Reload(keepPage: boolean) {
        if (keepPage === true) {
            await this.ChangePage(this.CurrentPage);
        } else {
            await this.ChangePage(1);
        }
    }

    private GetVisibleColumns() {
        return this.options.Columns.filter((col) => {
            return col.Visible === true;
        });
    }

    private paginationRange() {
        let start = 0;

        if (this.CurrentPage - this.PageRange / 2 <= 0) {
            start = 1;
        } else {
            if (this.CurrentPage + this.PageRange / 2 > this.TotalPages) {
                start = this.TotalPages - this.PageRange + 1 >= 1 ? this.TotalPages - this.PageRange + 1 : 1;
            } else {
                start = Math.ceil(this.CurrentPage - this.PageRange / 2);
            }
        }

        const range = [];

        for (let i = 0; i < this.PageRange && i < this.TotalPages; i++) {
            range.push(start + i);
        }

        return range;
    }

    private async ChangePage(page: number) {
        this.IsLoading = true;
        this.CurrentPage = page;
        let gridData: any;
        if (this.options.ServerLoad && this.options.MethodEndpoint.length > 0) {
            const gridService: DataGridService = new DataGridService();
            const response = await gridService
                .LoadFromServer(
                    this.options.MethodEndpoint,
                    this.options.PageSize,
                    this.CurrentPage,
                    this.LocalSearchTerms);
            gridData = response.Data;
        } else {
            if (this.options.GridData != null) {
                gridData = {
                    data: this.options.GridData.filter((row: number, index: number) => {
                        let start = (this.CurrentPage - 1) * this.options.PageSize;
                        let end = this.CurrentPage * this.options.PageSize;
                        if (index >= start && index < end) return true;
                    }),
                    total: this.options.GridData.length
                };
            } else {
                gridData = {
                    data: [],
                    total: 0
                };
            }
        }

        // const postData = {
        //     PageSize: this.options.PageSize,
        //     PageNumber: this.CurrentPage,
        //     SearchTerms: this.LocalSearchTerms
        // };

        // const response: AxiosResponse = await this.$http.post(this.options.MethodEndpoint, postData,
        //     { headers: { Authorization: 'Bearer ' + this.$store.state.userToken } });

        this.TotalPages = Math.floor(gridData.total / this.options.PageSize);

        if (gridData.total % this.options.PageSize > 0) {
            this.TotalPages++;
        }

        const items = gridData.data.map((val: any) => ({
            RowData: val,
            IsExpanded: false,
            IsSelected: false,
            ToggleDetails: this.HasDetails() ? (item: DataGridRowObject) => {
                item.IsExpanded = !item.IsExpanded;
            } : null
        }));

        // If Virtual scrolling is enabled append data instead of replacing them.
        if (this.options.VirtualScrolling) {
            if (page === 1) {
                this.GridData = [];
            }

            for (const item of items) {
                this.GridData.push(item);
            }
        } else {
            this.GridData = items;
        }
        this.IsLoading = false;
    }

    private SortTable(column: string) {
        // this.GridData.sort((a: object, b:object): number=>{
        //     var aa: object  = a[column];
        //     if (a[column]<b[column]) return -1;
        //     if (a[column]>b[column]) return 1;
        //     return 0;
        // });
    }

    private DeleteRow(id: number) {
        const popupOptions = {
            title: `Delete ${this.options.EntityName}`,
            size: 'sm',
            okVariant: 'danger',
            buttonSize: 'sm',
            okTitle: 'Yes',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
        };

        this.$bvModal.msgBoxConfirm('Are you sure you want to delete the selected row?', popupOptions)
            .then(async (answer) => {
                try {
                    if (answer === true) {
                        const endpoint = this.options.DeleteMethodEndpoint;
                        await this.$http.put(`${endpoint}?id=${id}`);

                        await this.ChangePage(this.CurrentPage);
                        this.$emit('deletefinished');
                    }
                } catch (exception) {
                    this.$bvModal.msgBoxOk(`Delete failed with error: ${exception}`);
                }
            });
    }

    private Scroll(e: any) {
        // const elem = this.$el;
        if (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight) {
            this.ChangePage(this.CurrentPage + 1);
        }
    }

    private SelectRow(item: DataGridRowObject) {
        if (!this.options.RowSelection) {
            return;
        }

        // Find and deselect current selected row.
        const selectedRow = this.GridData.find((selected: DataGridRowObject) => selected.IsSelected === true);

        if (selectedRow != null) {
            selectedRow.IsSelected = false;
        }

        // Select row.
        item.IsSelected = true;
        // Emit selection event.
        this.$router.push(this.options.UrlRouting + item.RowData.Id);
    }

    private ShowNewItemRow() {
        this.NewItemRow.ToggleDetails(this.NewItemRow);
    }
}
